import { useEffect, useRef, useState } from 'react';
import { getDiscoverCredentialsAPI, getUserCredentialsAPI } from './utils/profileCredentials';
import { ICredential } from '../model';

export function useProfileCredentials(username: string) {
  const hasFetchedData = useRef(false);

  const [userCredentials, setUserCredentials] = useState<ICredential[]>([]);
  const [userCredentialsLoaded, setUserCredentialsLoaded] =
    useState<boolean>(false);
  const [discoverCredentials, setDiscoverCredentials] = useState<ICredential[]>(
    []
  );
  const [discoverCredentialsLoaded, setDiscoverCredentialsLoaded] =
    useState<boolean>(false);
  useEffect(() => {
    if (!hasFetchedData.current) {
      getUserCredentialsAPI(username, userCredentialsCallback);
      getDiscoverCredentialsAPI(username, discoverCredentialsCallback);
      hasFetchedData.current = true;
    }
  }, [username]);

  const userCredentialsCallback = (data) => {
    setUserCredentials(data as ICredential[]);
    setUserCredentialsLoaded(true);
  };
  const discoverCredentialsCallback = (data) => {
    setDiscoverCredentials(data);
    setDiscoverCredentialsLoaded(true);
  };

  return {
    userCredentials,
    userCredentialsLoaded,
    discoverCredentials,
    discoverCredentialsLoaded,
  };
}
